import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { useFilterModulesStore } from 'components/filter/filters-next/filterModules';
import { RelationalServerKey, ServerKey } from 'components/filter/types';

interface FilterIconStrategyProps extends Omit<FontAwesomeIconProps, 'icon'> {
    serverKey: ServerKey;
    relationalServerKey?: RelationalServerKey;
}

const FilterIconStrategy = (props: FilterIconStrategyProps) => {
    const { serverKey, relationalServerKey, ...rest } = props;
    const filterModules = useFilterModulesStore(state => state.modules);
    const filterModule = filterModules[serverKey];
    const Icon = filterModule?.Icon;

    if (Icon) {
        return (
            <FontAwesomeIcon
                icon={
                    typeof Icon === 'function'
                        ? Icon({ strategyType: serverKey, relationalServerKey })
                        : Icon
                }
                {...rest}
            />
        );
    }

    return null;
};

export { FilterIconStrategy };
